import {Component, OnInit, ViewChildren, ViewChild, QueryList, Input} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PerioService } from './services/perio.service';
import { Globals } from '../../globals';

import { PerioToothComponent } from './perio-tooth/perio-tooth.component';
import { PerioToothDetailsComponent } from './perio-tooth-details/perio-tooth-details.component';
import { ProbingDepthSegmentsSummaryComponent } from './depth-segments-summary/probing-summary.component';
import { ProbingDepthSummaryComponent } from './depth-summary/probing-depth-summary.component';
import { ToothSummaryComponent } from './tooth-summary/tooth-summary.component';
import { NoteCompactComponent } from '../notes/note-compact/note-compact.component';
import {
  CurrentPatient,
  ControlSetup,
  PerioChart,
  ValidationParameters,
  PerioTooth,
  PerioToothIndex,
  PerioSummaryStats,
  PerioSummarySelect,
  PerioSummarySelectType,
} from './models/perio.models';
import {DatePipe} from '@angular/common';
import {UiService} from '../../services/ui.service';
import {MatMenuTrigger} from '@angular/material/menu';
import {ReportGlobalParametersModel} from '../reports/models/ReportGlobalParameters.model';
import {ReportStartUpInstructionsModel} from '../reports/models/ReportStartUpInstructions.model';
import {ReportStartUpObjectModel} from '../reports/models/ReportStartUpObject.model';
import {Constants} from '../../constants';
import {TdoNoteQueryModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {NotesService} from '../../services/notes.service';


@Component({
  standalone: false,
  selector: 'app-perio',
  templateUrl: './perio.component.html',
  styleUrls: ['./perio.component.css'],
})
export class PerioComponent implements OnInit {

  @ViewChild('perioToothDetails') perioToothDetails: PerioToothDetailsComponent;
  @ViewChildren('perioTooth') perioToothComponents: QueryList<PerioToothComponent>;
  @ViewChild('patientNotes') patientNotes: NoteCompactComponent;

  @Input() caseWorkItemFormsId: string;





  // we create an object that contains coordinates
  menuTopLeftPosition =  {x: '0', y: '0'};

  // reference to the MatMenuTrigger in the DOM
  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger: MatMenuTrigger;

  chartlist: PerioChart[] = [];
  chartTeeth: PerioTooth[] = [];
  chartTeethComparison: PerioTooth[] = [];
  controlSetupList: ControlSetup[] = [];
  validationCriteria: ValidationParameters[] = [];

  selectedPerioTooth: PerioTooth;
  selectedToothSection: string;
  selectedToothFacing: string;
  selectedToothIndex: number;
  ToothNumber: number;
  isComparison: boolean = false;


  ComparisonReportID: string = '9000000A-1000-0000-0000-000000000016';
  PerioChartReportID: string = '9000000A-1000-0000-0000-000000000017';



  DotXD: number = 25;
  DotXC: number = 35;
  DotXM: number = 45;

  DotYD: number = 132;
  DotYC: number = 132;
  DotYM: number = 132;

  summaryStats: PerioSummaryStats = new PerioSummaryStats();

  patientId: string;
  objectId: string;
  currentPatient: CurrentPatient;

  detailControlKey: string;

  buccalUpper: string = 'white';
  buccalLower: string = 'white';
  lingualUpper: string = 'white';
  lingualLower: string = 'white';

  isLoading: boolean = false;

  currentPerioChartID: string;
  currentPerioChartDescription: string;
  upperTeethIndices: PerioToothIndex[] = Array(16).fill(0).map((x, i) => ({ imageIndex: i, index: i }));
  lowerTeethIndices: PerioToothIndex[] = Array(16).fill(0).map((x, i) => ({ imageIndex: i + 16, index: (i + 16) })).reverse();

  summaryList: PerioSummarySelect[] = [
    { name: 'Perio Screening Score', type: PerioSummarySelectType.ScreeningScore },
    { name: 'General Summary', type: PerioSummarySelectType.ProbingDepths },
    { name: 'Tooth Summary', type: PerioSummarySelectType.ToothSummary },
  ];

  polyLineSegments: any = {
    middleContainerWidth: 0,
  };

  constructor(
    private perioService: PerioService,
    private dialog: MatDialog,
    public globals: Globals,
    public uiService: UiService,
    private notesService: NotesService
  ) {
  }

  ngOnInit() {
    if (this.globals.ThePatient) {

      this.patientId = this.globals.ThePatient.PatientId;
      this.objectId = this.globals.ThePatient.PatientId;

      this.currentPatient = {
        PatientID: this.patientId,
        ObjectId: this.objectId,
        PatientName: this.globals.ThePatient.dataContact.FirstName,
        ParentObjectName: 'dataPatient',
      };

      this.uiService.isCaseViewMinimized = true;

      // call server to check if caseWorkItemFormsId is related to any perio char
      this.isLoading = true;
      this.perioService.getPerioTeethIdByCaseWorkItemForm(this.caseWorkItemFormsId)
        .subscribe((perioTeethId: string) => {

          if (perioTeethId === Constants.emptyGuid) {
            // if no PerioTeeth associated with caseWorkItemFormId, create a new one
            this.onCreateChartClicked();
          }
          else{
            this.currentPerioChartID = perioTeethId;

            const promises = [
            this.perioService.getChartList(this.patientId).toPromise(),
          ];
            // this.isLoading = true;
            Promise.all(promises).then((results: any[]) => {
            const chartData: PerioChart[] = results[0];
            this.chartlist = chartData;

            /*this.chartlist = this.chartlist.sort((a, b) => {
              const d1 = new Date(a.xauditModifiedOn);
              const d2 = new Date(b.xauditModifiedOn);
              return d2.getTime() - d1.getTime();
            });*/

            if (this.chartlist.length > 0) {
              /*if (!this.currentPerioChartID) {
                this.currentPerioChartID = //this.chartlist[0].PerioChartID;
              }*/
              this.loadToothDataForCurrentChart(this.currentPerioChartID);
            } else {
              this.isLoading = false;
            }

          }, err => {
            console.log('ERROR', err);
            this.isLoading = false;
          });
          }

          const promisesConfig = [
          this.perioService.getControlConfig(),
          ];
          Promise.all(promisesConfig).then((results: any[]) => {
            const controlSetupList: ControlSetup[] = results[0];
            this.controlSetupList = controlSetupList;
          });
        }, (error) => {
          console.log(error);
        });

    } else {
      // this shouldn't happen, you should always have a patient to get to perio
      return;
    }
  }

  openSummary(item: PerioSummarySelect) {

    if (this.isLoading || !this.chartTeeth) {
      return;
    }

    if (item.type === PerioSummarySelectType.ScreeningScore) {
      const dialogRef = this.dialog.open(ProbingDepthSegmentsSummaryComponent, {
        data: {
          chartTeeth: this.chartTeeth,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    } else if (item.type === PerioSummarySelectType.ProbingDepths) {
      const dialogRef = this.dialog.open(ProbingDepthSummaryComponent, {
        data: {
          chartTeeth: this.chartTeeth,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    } else if (item.type === PerioSummarySelectType.ToothSummary) {
      const dialogRef = this.dialog.open(ToothSummaryComponent, {
        data: {
          chartTeeth: this.chartTeeth,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }

  }

  upperTeethCount(toothIndex: number, items: any){
    if (toothIndex !== 0)
    {
      this.DotXD = this.DotXD + 75;
      this.DotXC = this.DotXD + 75;
      this.DotXM = this.DotXD + 75;

      /*DotYD: number = 132;
      DotYC: number = 132;
      DotYM: number = 132;*/
    }
    return toothIndex;

  }


  isToday(date: string): boolean {
    const today = Date.now();
    const dateValue: Date = new Date(date);
    const dateValueNumeric: number = dateValue.getTime();
    const todayDate = this.getShortDateDisplay(today);
    const otherDate = this.getShortDateDisplay(dateValueNumeric);

    const isToday = (todayDate === otherDate);
    return isToday;
  }

  getShortDateDisplay(dateValue: number){
    const datePipe = new DatePipe('en-US');
    const d = new Date(dateValue);
    return datePipe.transform(d, 'shortDate');
  }


  handleEndOfInputReached(nextControlKey: string, foundMissingFlag: boolean = false) {

    let facing: string = this.selectedToothFacing;
    let section: string = this.selectedToothSection;
    const nextToothIndex: number = parseInt(nextControlKey.split('pt')[1].split('_')[0]) - 1;

    if (nextToothIndex < 16) {
      section = 'upper';
    } else {
      section = 'lower';
    }

    const containsLingual: boolean = nextControlKey.toLowerCase().indexOf('lingual') > -1;

    if (containsLingual) {
      facing = 'lingual';
    } else {
      facing = 'buccal';
    }

    if (this.chartTeeth[nextToothIndex].ToothIsMissing) {

      // must find the next control key
      // but be careful, you need to make sure you arent going the wrong pay

      let skipControlKeyIndex: number = this.controlSetupList.findIndex(control => {
        return control.controlkey === nextControlKey;
      });

      skipControlKeyIndex++;

      if (skipControlKeyIndex >= this.controlSetupList.length) {
        skipControlKeyIndex = 0;
      }

      const skipControlKeyString: string = this.controlSetupList[skipControlKeyIndex].controlkey;
      this.handleEndOfInputReached(skipControlKeyString, true);

    } else {
      setTimeout(_ => {
        // this timeout is needed to give the angular change detection a second to catch up with
        // the instant change from one input value to the next
        this.selectTooth(this.chartTeeth[nextToothIndex], section, facing, nextToothIndex);

        if (foundMissingFlag) {
          // need to tell the detail to update it's control key
          this.perioToothDetails.focusOnNextInputElement(nextControlKey);
        }

      }, 100);
    }

  }

  selectTooth(tooth: PerioTooth, section: string, facing: string, index: number) {
    this.selectedPerioTooth = tooth;
    this.selectedToothSection = section;
    this.selectedToothFacing = facing;
    this.selectedToothIndex = index;

    if (this.perioToothDetails) {
      this.perioToothDetails.handleToothChangeForInputFields(index + 1);
    }
    this.buccalUpper = 'white';
    this.lingualUpper = 'white';
    this.lingualLower = 'white';
    this.buccalLower = 'white';
    if (section === 'upper' && facing === 'buccal') {
      this.buccalUpper = 'var(--tdo-purple-light)';
    } else if (section === 'upper' && facing === 'lingual')
    {
      this.lingualUpper = 'var(--tdo-blue-light)';
    } else if (section === 'lower' && facing === 'lingual')
    {
      this.lingualLower = 'var(--tdo-blue-light)';
    }else if (section === 'lower' && facing === 'buccal')
    {
      this.buccalLower = 'var(--tdo-purple-light)';
    }

    this.ToothNumber = index + 1;

  }

  loadToothDataForComparisonChart(perioChartID: string) {
    this.isLoading = true;
    this.perioService.getPerioTeethApi(perioChartID)
      .subscribe((perioTeeth: PerioTooth[]) => {

        if (perioTeeth === null) {
          this.isLoading = false;
          return;
        }

        this.chartTeethComparison = perioTeeth;
        this.isLoading = false;
        this.executeComparison();

      }, (error) => {
        console.log(error);
      });
  }

  executeComparison() {
    if (!this.isComparison){
      return;
    }

    let i: number = 0;
    for (const currentTooth of this.chartTeeth) {
      // Facial
      if (((currentTooth.FacialBleedingC !== this.chartTeethComparison[i].FacialBleedingC) && currentTooth.FacialBleedingC === true) ||
        ((currentTooth.FacialBleedingD !== this.chartTeethComparison[i].FacialBleedingD) && currentTooth.FacialBleedingD === true) ||
        ((currentTooth.FacialBleedingM !== this.chartTeethComparison[i].FacialBleedingM) && currentTooth.FacialBleedingM === true) ||
        ((currentTooth.FacialSuppurationM !== this.chartTeethComparison[i].FacialSuppurationM) && currentTooth.FacialSuppurationM === true) ||
        ((currentTooth.FacialSuppurationC !== this.chartTeethComparison[i].FacialSuppurationC) && currentTooth.FacialSuppurationC === true) ||
        ((currentTooth.FacialSuppurationD !== this.chartTeethComparison[i].FacialSuppurationD) && currentTooth.FacialSuppurationD === true) ||
        ((currentTooth.FacialCalculusD !== this.chartTeethComparison[i].FacialCalculusD) && currentTooth.FacialCalculusD === true) ||
        ((currentTooth.FacialCalculusC !== this.chartTeethComparison[i].FacialCalculusC) && currentTooth.FacialCalculusC === true) ||
        ((currentTooth.FacialCalculusM !== this.chartTeethComparison[i].FacialCalculusM) && currentTooth.FacialCalculusM === true) ||
        ((currentTooth.FacialPlaqueM !== this.chartTeethComparison[i].FacialPlaqueM) && currentTooth.FacialPlaqueM === true) ||
        ((currentTooth.FacialPlaqueC !== this.chartTeethComparison[i].FacialPlaqueC) && currentTooth.FacialPlaqueC === true) ||
        ((currentTooth.FacialPlaqueD !== this.chartTeethComparison[i].FacialPlaqueD) && currentTooth.FacialPlaqueD === true) ||
        (Number(currentTooth.FacialProbingDepthD) > this.chartTeethComparison[i].FacialProbingDepthD) ||
        (Number(currentTooth.FacialProbingDepthC) > this.chartTeethComparison[i].FacialProbingDepthC) ||
        (Number(currentTooth.FacialProbingDepthM) > this.chartTeethComparison[i].FacialProbingDepthM) ||
        (Number(currentTooth.FacialGingovalMarginD) > this.chartTeethComparison[i].FacialGingovalMarginD) ||
        (Number(currentTooth.FacialGingovalMarginC) > this.chartTeethComparison[i].FacialGingovalMarginC) ||
        (Number(currentTooth.FacialGingovalMarginM) > this.chartTeethComparison[i].FacialGingovalMarginM) ||
        (Number(currentTooth.FacialClinicalAttachmentLevelD) > this.chartTeethComparison[i].FacialClinicalAttachmentLevelD) ||
        (Number(currentTooth.FacialClinicalAttachmentLevelC) > this.chartTeethComparison[i].FacialClinicalAttachmentLevelC) ||
        (Number(currentTooth.FacialClinicalAttachmentLevelM) > this.chartTeethComparison[i].FacialClinicalAttachmentLevelM) ||
        (currentTooth.ToothFurcationGrade > this.chartTeethComparison[i].ToothFurcationGrade) ||
        (currentTooth.ToothMobility > this.chartTeethComparison[i].ToothMobility))
      {
        this['facialComparison' + [i]] = 'bad';
      } else if ((currentTooth.FacialBleedingC === this.chartTeethComparison[i].FacialBleedingC) &&
        (currentTooth.FacialBleedingD === this.chartTeethComparison[i].FacialBleedingD)  &&
        (currentTooth.FacialBleedingM === this.chartTeethComparison[i].FacialBleedingM)  &&
        (currentTooth.FacialSuppurationM === this.chartTeethComparison[i].FacialSuppurationM)  &&
        (currentTooth.FacialSuppurationC === this.chartTeethComparison[i].FacialSuppurationC)  &&
        (currentTooth.FacialSuppurationD === this.chartTeethComparison[i].FacialSuppurationD)  &&
        (currentTooth.FacialCalculusD === this.chartTeethComparison[i].FacialCalculusD)  &&
        (currentTooth.FacialCalculusC === this.chartTeethComparison[i].FacialCalculusC)  &&
        (currentTooth.FacialCalculusM === this.chartTeethComparison[i].FacialCalculusM)  &&
        (currentTooth.FacialPlaqueM === this.chartTeethComparison[i].FacialPlaqueM)  &&
        (currentTooth.FacialPlaqueC === this.chartTeethComparison[i].FacialPlaqueC)  &&
        (currentTooth.FacialPlaqueD === this.chartTeethComparison[i].FacialPlaqueD)  &&
        (Number(currentTooth.FacialProbingDepthD) === this.chartTeethComparison[i].FacialProbingDepthD) &&
        (Number(currentTooth.FacialProbingDepthC) === this.chartTeethComparison[i].FacialProbingDepthC) &&
        (Number(currentTooth.FacialProbingDepthM) === this.chartTeethComparison[i].FacialProbingDepthM) &&
        (Number(currentTooth.FacialGingovalMarginD) === this.chartTeethComparison[i].FacialGingovalMarginD) &&
        (Number(currentTooth.FacialGingovalMarginC) === this.chartTeethComparison[i].FacialGingovalMarginC) &&
        (Number(currentTooth.FacialGingovalMarginM) === this.chartTeethComparison[i].FacialGingovalMarginM) &&
        (Number(currentTooth.FacialClinicalAttachmentLevelD) === this.chartTeethComparison[i].FacialClinicalAttachmentLevelD) &&
        (Number(currentTooth.FacialClinicalAttachmentLevelC) === this.chartTeethComparison[i].FacialClinicalAttachmentLevelC) &&
        (Number(currentTooth.FacialClinicalAttachmentLevelM) === this.chartTeethComparison[i].FacialClinicalAttachmentLevelM) &&
        (currentTooth.ToothFurcationGrade === this.chartTeethComparison[i].ToothFurcationGrade) &&
        (currentTooth.ToothMobility === this.chartTeethComparison[i].ToothMobility))
      {
        this['facialComparison' + [i]] = 'equals';
      }
      else {
        this['facialComparison' + [i]] = 'good';
      }

      // Lingual
      if (((currentTooth.LingualBleedingC !== this.chartTeethComparison[i].LingualBleedingC) && currentTooth.LingualBleedingC === true) ||
        ((currentTooth.LingualBleedingD !== this.chartTeethComparison[i].LingualBleedingD) && currentTooth.LingualBleedingD === true) ||
        ((currentTooth.LingualBleedingM !== this.chartTeethComparison[i].LingualBleedingM) && currentTooth.LingualBleedingM === true) ||
        ((currentTooth.LingualSuppurationM !== this.chartTeethComparison[i].LingualSuppurationM) && currentTooth.LingualSuppurationM === true) ||
        ((currentTooth.LingualSuppurationC !== this.chartTeethComparison[i].LingualSuppurationC) && currentTooth.LingualSuppurationC === true) ||
        ((currentTooth.LingualSuppurationD !== this.chartTeethComparison[i].LingualSuppurationD) && currentTooth.LingualSuppurationD === true) ||
        ((currentTooth.LingualCalculusD !== this.chartTeethComparison[i].LingualCalculusD) && currentTooth.LingualCalculusD === true) ||
        ((currentTooth.LingualCalculusC !== this.chartTeethComparison[i].LingualCalculusC) && currentTooth.LingualCalculusC === true) ||
        ((currentTooth.LingualCalculusM !== this.chartTeethComparison[i].LingualCalculusM) && currentTooth.LingualCalculusM === true) ||
        ((currentTooth.LingualPlaqueM !== this.chartTeethComparison[i].LingualPlaqueM) && currentTooth.LingualPlaqueM === true) ||
        ((currentTooth.LingualPlaqueC !== this.chartTeethComparison[i].LingualPlaqueC) && currentTooth.LingualPlaqueC === true) ||
        ((currentTooth.LingualPlaqueD !== this.chartTeethComparison[i].LingualPlaqueD) && currentTooth.LingualPlaqueD === true) ||
        (Number(currentTooth.LingualProbingDepthD) > this.chartTeethComparison[i].LingualProbingDepthD) ||
        (Number(currentTooth.LingualProbingDepthC) > this.chartTeethComparison[i].LingualProbingDepthC) ||
        (Number(currentTooth.LingualProbingDepthM) > this.chartTeethComparison[i].LingualProbingDepthM) ||
        (Number(currentTooth.LingualGingovalMarginD) > this.chartTeethComparison[i].LingualGingovalMarginD) ||
        (Number(currentTooth.LingualGingovalMarginC) > this.chartTeethComparison[i].LingualGingovalMarginC) ||
        (Number(currentTooth.LingualGingovalMarginM) > this.chartTeethComparison[i].LingualGingovalMarginM) ||
        (Number(currentTooth.LingualClinicalAttachmentLevelD) > this.chartTeethComparison[i].LingualClinicalAttachmentLevelD) ||
        (Number(currentTooth.LingualClinicalAttachmentLevelC) > this.chartTeethComparison[i].LingualClinicalAttachmentLevelC) ||
        (Number(currentTooth.LingualClinicalAttachmentLevelM) > this.chartTeethComparison[i].LingualClinicalAttachmentLevelM) ||
        (currentTooth.ToothFurcationGrade > this.chartTeethComparison[i].ToothFurcationGrade) ||
        (currentTooth.ToothMobility > this.chartTeethComparison[i].ToothMobility))
      {
        this['lingualComparison' + [i]] = 'bad';
      } else if ((currentTooth.LingualBleedingC === this.chartTeethComparison[i].LingualBleedingC) &&
        (currentTooth.LingualBleedingD === this.chartTeethComparison[i].LingualBleedingD)  &&
        (currentTooth.LingualBleedingM === this.chartTeethComparison[i].LingualBleedingM)  &&
        (currentTooth.LingualSuppurationM === this.chartTeethComparison[i].LingualSuppurationM)  &&
        (currentTooth.LingualSuppurationC === this.chartTeethComparison[i].LingualSuppurationC)  &&
        (currentTooth.LingualSuppurationD === this.chartTeethComparison[i].LingualSuppurationD)  &&
        (currentTooth.LingualCalculusD === this.chartTeethComparison[i].LingualCalculusD)  &&
        (currentTooth.LingualCalculusC === this.chartTeethComparison[i].LingualCalculusC)  &&
        (currentTooth.LingualCalculusM === this.chartTeethComparison[i].LingualCalculusM)  &&
        (currentTooth.LingualPlaqueM === this.chartTeethComparison[i].LingualPlaqueM)  &&
        (currentTooth.LingualPlaqueC === this.chartTeethComparison[i].LingualPlaqueC)  &&
        (currentTooth.LingualPlaqueD === this.chartTeethComparison[i].LingualPlaqueD)  &&
        (Number(currentTooth.LingualProbingDepthD) === this.chartTeethComparison[i].LingualProbingDepthD) &&
        (Number(currentTooth.LingualProbingDepthC) === this.chartTeethComparison[i].LingualProbingDepthC) &&
        (Number(currentTooth.LingualProbingDepthM) === this.chartTeethComparison[i].LingualProbingDepthM) &&
        (Number(currentTooth.LingualGingovalMarginD) === this.chartTeethComparison[i].LingualGingovalMarginD) &&
        (Number(currentTooth.LingualGingovalMarginC) === this.chartTeethComparison[i].LingualGingovalMarginC) &&
        (Number(currentTooth.LingualGingovalMarginM) === this.chartTeethComparison[i].LingualGingovalMarginM) &&
        (Number(currentTooth.LingualClinicalAttachmentLevelD) === this.chartTeethComparison[i].LingualClinicalAttachmentLevelD) &&
        (Number(currentTooth.LingualClinicalAttachmentLevelC) === this.chartTeethComparison[i].LingualClinicalAttachmentLevelC) &&
        (Number(currentTooth.LingualClinicalAttachmentLevelM) === this.chartTeethComparison[i].LingualClinicalAttachmentLevelM) &&
        (currentTooth.ToothFurcationGrade === this.chartTeethComparison[i].ToothFurcationGrade) &&
        (currentTooth.ToothMobility === this.chartTeethComparison[i].ToothMobility))
      {
        this['lingualComparison' + [i]] = 'equals';
      }
      else {
        this['lingualComparison' + [i]] = 'good';
      }
      i++;
    }
  }

   loadToothDataForCurrentChart(perioChartID: string, ignoreDoubleLoad: boolean = false) {

    this.chartlist.map(d => d.isComparing = false);
    this.isComparison = false;
    /*data.map(d =>
      this.getLastStatus(d.id).pipe(
        map(status => ({ ...d, d.status: status }))
  )*/
    if (ignoreDoubleLoad && this.currentPerioChartID === perioChartID) {
      return;
    }

    this.currentPerioChartID = perioChartID;
    this.currentPerioChartDescription = this.chartlist.find(x => x.PerioChartID === perioChartID).Description;

     // call notes
    this.filterNotesByGroupObject(this.currentPerioChartID);

    this.isLoading = true;
    this.perioService.getPerioTeethApi(this.currentPerioChartID)
      .subscribe((perioTeeth: PerioTooth[]) => {

        if (perioTeeth === null) {
          this.isLoading = false;
          return;
        }

        this.chartTeeth = perioTeeth;

        let firstNonMissingToothIndex = this.chartTeeth.findIndex(tooth => !tooth.ToothIsMissing);

        if (firstNonMissingToothIndex === -1) {
          firstNonMissingToothIndex = 0;
        }

        // test for now
        firstNonMissingToothIndex = 0;
        this.selectTooth(this.chartTeeth[firstNonMissingToothIndex], 'upper', 'buccal', firstNonMissingToothIndex);

        this.calcPerioSummary();

        if (this.patientNotes) {
          this.patientNotes.initWithQueryObj();
        }

        this.isLoading = false;
      }, (error) => {
        console.log(error);
      });
  }

  onRightClick(event: MouseEvent, item: string , currentContent: string ) {

   // preventDefault avoids to show the visualization of the right-click menu of the browser
    event.preventDefault();
    /*if (item === currentContent){
      return;
    }*/

    // we record the mouse position in our object
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';

    // we open the menu
    // we pass to the menu the information about our object
    this.matMenuTrigger.menuData = {item};

    // we open the menu
    this.matMenuTrigger.openMenu();

  }

  async onCreateChartClicked() {

    this.isLoading = true;

    try {
      const newChartId: string = await this.perioService.createNewPerioTeethChart(this.patientId, this.caseWorkItemFormsId).toPromise();
      const chartData: PerioChart[] = await this.perioService.getChartList(this.patientId).toPromise();

      this.chartlist = chartData;

      this.chartlist = this.chartlist.sort((a, b) => {
        // const d1 = new Date(a.xauditModifiedOn);
        // const d2 = new Date(b.xauditModifiedOn);
        const d1 = new Date(a.xauditCreatedOn);
        const d2 = new Date(b.xauditCreatedOn);
        return d2.getTime() - d1.getTime();
      });

      this.currentPerioChartID = newChartId;
      this.loadToothDataForCurrentChart(this.currentPerioChartID);

    } catch (err) {
      console.log('error', err);
    }

  }

  calcPerioSummary() {
    // probing level

    let probingLevel: number = 0;
    let probingLevelCount: number = 0;

    const probingDepthKeys: string[] = [
      'FacialProbingDepthD',
      'FacialProbingDepthC',
      'FacialProbingDepthM',
      'LingualProbingDepthD',
      'LingualProbingDepthC',
      'LingualProbingDepthM'
    ];

    this.chartTeeth.forEach(tooth => {
      if (!tooth.ToothIsMissing) {
        probingDepthKeys.forEach(key => {
          const value = parseInt(tooth[key]);
          if (value === 0 || value) {
            probingLevel += value;
            probingLevelCount++;
          }
        });
      }
    });

    if (probingLevelCount) {
      probingLevel = probingLevel / probingLevelCount;
      this.summaryStats.meanProbingDepth = `${probingLevel}`;

      if (this.summaryStats.meanProbingDepth.length > 3) {
        this.summaryStats.meanProbingDepth = this.summaryStats.meanProbingDepth.slice(0, 3);
      }

    } else {
      this.summaryStats.meanProbingDepth = '0';
    }

    // attachment level

    let attachmentLevel: number = 0;
    let attachmentLevelCount: number = 0;

    const attachmentLevelKeys: string[] = [
      'FacialClinicalAttachmentLevelD',
      'FacialClinicalAttachmentLevelC',
      'FacialClinicalAttachmentLevelM',
      'LingualClinicalAttachmentLevelD',
      'LingualClinicalAttachmentLevelC',
      'LingualClinicalAttachmentLevelM'
    ];

    this.chartTeeth.forEach(tooth => {
      if (!tooth.ToothIsMissing) {
        attachmentLevelKeys.forEach(key => {
          const value = parseInt(tooth[key]);
          if (value === 0 || value) {
            attachmentLevel += value;
            attachmentLevelCount++;
          }
        });
      }
    });

    if (attachmentLevelCount) {
      attachmentLevel = attachmentLevel / attachmentLevelCount;
      this.summaryStats.meanAttachmentLevel = `${attachmentLevel}`;

      if (this.summaryStats.meanAttachmentLevel.length > 3) {
        this.summaryStats.meanAttachmentLevel = this.summaryStats.meanAttachmentLevel.slice(0, 3);
      }

    } else {
      this.summaryStats.meanAttachmentLevel = '0';
    }

    // plaque

    let plaqueLevel: number = 0;
    let plaqueCount: number = 0;

    const plaqueLevelKeys: string[] = [
      'FacialPlaqueD',
      'FacialPlaqueC',
      'FacialPlaqueM',
      'LingualPlaqueD',
      'LingualPlaqueC',
      'LingualPlaqueM'
    ];

    this.chartTeeth.forEach(tooth => {
      if (!tooth.ToothIsMissing) {
        plaqueLevelKeys.forEach(key => {
          if (tooth[key] === true) {
            plaqueLevel++;
          }
          plaqueCount++;
        });
      }
    });

    if (plaqueLevel) {

      plaqueLevel = plaqueLevel / plaqueCount;
      plaqueLevel = plaqueLevel * 100;

      plaqueLevel = Math.round(plaqueLevel * 10) / 10;

      this.summaryStats.plaquePercent = `${plaqueLevel}`;

      if (this.summaryStats.plaquePercent.length > 5) {
        this.summaryStats.plaquePercent = this.summaryStats.plaquePercent.slice(0, 5);
      }

      this.summaryStats.plaquePercent += '%';

    } else {
      this.summaryStats.plaquePercent = '0%';
    }

    // bleeding

    let bleedingLevel: number = 0;
    let bleedingCount: number = 0;

    const bleedingLevelKeys: string[] = [
      'FacialBleedingD',
      'FacialBleedingC',
      'FacialBleedingM',
      'LingualBleedingD',
      'LingualBleedingC',
      'LingualBleedingM'
    ];

    this.chartTeeth.forEach(tooth => {
      if (!tooth.ToothIsMissing) {
        bleedingLevelKeys.forEach(key => {
          if (tooth[key] === true) {
            bleedingLevel++;
          }
          bleedingCount++;
        });
      }
    });

    if (bleedingLevel) {

      bleedingLevel = bleedingLevel / bleedingCount;
      bleedingLevel = bleedingLevel * 100;

      bleedingLevel = Math.round(bleedingLevel * 10) / 10;

      this.summaryStats.bleedingPercent = `${bleedingLevel}`;

      if (this.summaryStats.bleedingPercent.length > 5) {
        this.summaryStats.bleedingPercent = this.summaryStats.bleedingPercent.slice(0, 5);
      }

      this.summaryStats.bleedingPercent += '%';

    } else {
      this.summaryStats.bleedingPercent = '0%';
    }
  }

  getPolyLineGuideLine(section: string, facing: string) {

    const midElement = document.getElementById('middle-container');
    const midElementWidth: number = midElement.offsetWidth;

    if (section === 'upper' && facing === 'buccal') {
      return `00, 110, ${midElementWidth}, 110`;
    } else if (section === 'upper' && facing === 'lingual') {
      // return `00, 70, ${midElementWidth}, 70`;
      return `00, 105, ${midElementWidth}, 105`;
    } else if (section === 'lower' && facing === 'buccal') {
      // return `00, 75, ${midElementWidth}, 75`;
      return `00, 105, ${midElementWidth}, 105`;
    } else if (section === 'lower' && facing === 'lingual') {
      return `00, 100, ${midElementWidth}, 100`;

    }

  }

  getIssueDotXForAttribute(section: string, facing: string, type: string) {
    if (section === 'upper' && facing === 'buccal') {
      if (type === 'FacialBleeding') {
        const issueKeys: string[] = [
          'FacialBleedingD',
          'FacialBleedingC',
          'FacialBleedingM',
        ];

      }





    }
  }
  getIssueDotYForAttribute(section: string, facing: string, type: string) {

  }

  getPolyLineForAttribute(section: string, facing: string, type: string) {

    // const toothWidth: number = 69;
    const toothWidth: number = 69;
    // let pointWidth: number = Math.round(toothWidth / 3);
    const pointWidth: number = toothWidth / 3;
    const offset: number = 7.5;

    if (section === 'upper' && facing === 'buccal') {

      if (type === 'probingDepth') {

        const baseline: number = 110;
        const typeBaseLine: number = 0;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'FacialProbingDepthD',
          'FacialProbingDepthC',
          'FacialProbingDepthM',
        ];

        // starting point, height (x, y)

        this.upperTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline - typeBaseLine) - (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'gingovalMargin') {

        const baseline: number = 110;
        const typeBaseLine: number = 10;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'FacialGingovalMarginD',
          'FacialGingovalMarginC',
          'FacialGingovalMarginM',
        ];

        // starting point, height (x, y)

        this.upperTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline - typeBaseLine) - (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline - typeBaseLine) - (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'attachmentLevel') {

        const baseline: number = 110;
        const typeBaseLine: number = 20;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'FacialClinicalAttachmentLevelD',
          'FacialClinicalAttachmentLevelC',
          'FacialClinicalAttachmentLevelM',
        ];

        // starting point, height (x, y)

        this.upperTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline - typeBaseLine) - (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline - typeBaseLine) - (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

    }
    else if (section === 'upper' && facing === 'lingual') {

      if (type === 'probingDepth') {

        /*const baseline: number = 70;*/
        const baseline: number = 105;
        const typeBaseLine: number = 0;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'LingualProbingDepthD',
          'LingualProbingDepthC',
          'LingualProbingDepthM',
        ];

        // starting point, height (x, y)

        this.upperTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline + typeBaseLine) + (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline + typeBaseLine) + (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'gingovalMargin') {

        /*const baseline: number = 70;*/
        const baseline: number = 105;
        const typeBaseLine: number = 10;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'LingualGingovalMarginD',
          'LingualGingovalMarginC',
          'LingualGingovalMarginM',
        ];

        // starting point, height (x, y)

        this.upperTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline + typeBaseLine) + (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline + typeBaseLine) + (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'attachmentLevel') {

        // const baseline: number = 70;
        const baseline: number = 105;
        const typeBaseLine: number = 20;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'LingualClinicalAttachmentLevelD',
          'LingualClinicalAttachmentLevelC',
          'LingualClinicalAttachmentLevelM',
        ];

        // starting point, height (x, y)

        this.upperTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline + typeBaseLine) + (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline + typeBaseLine) + (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

    }
    else if (section === 'lower' && facing === 'buccal') {

      if (type === 'probingDepth') {

        // const baseline: number = 75;
        const baseline: number = 110;
        const typeBaseLine: number = 0;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'FacialProbingDepthD',
          'FacialProbingDepthC',
          'FacialProbingDepthM',
        ];

        // starting point, height (x, y)

        this.lowerTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline + typeBaseLine) + (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline - typeBaseLine) - (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'gingovalMargin') {

        // const baseline: number = 75;
        const baseline: number = 110;
        const typeBaseLine: number = 10;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'FacialGingovalMarginD',
          'FacialGingovalMarginC',
          'FacialGingovalMarginM',
        ];

        // starting point, height (x, y)

        this.lowerTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline + typeBaseLine) + (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline - typeBaseLine) - (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'attachmentLevel') {

        // const baseline: number = 75;
        const baseline: number = 110;
        const typeBaseLine: number = 20;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'FacialClinicalAttachmentLevelD',
          'FacialClinicalAttachmentLevelC',
          'FacialClinicalAttachmentLevelM',
        ];

        // starting point, height (x, y)

        this.lowerTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline + typeBaseLine) + (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline - typeBaseLine) - (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

    }
    else if (section === 'lower' && facing === 'lingual') {

      if (type === 'probingDepth') {

        const baseline: number = 100;
        const typeBaseLine: number = 0;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'LingualProbingDepthD',
          'LingualProbingDepthC',
          'LingualProbingDepthM',
        ];

        // starting point, height (x, y)

        this.lowerTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline - typeBaseLine) - (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline + typeBaseLine) + (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'gingovalMargin') {

        const baseline: number = 100;
        const typeBaseLine: number = 10;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'LingualGingovalMarginD',
          'LingualGingovalMarginC',
          'LingualGingovalMarginM',
        ];

        // starting point, height (x, y)

        this.lowerTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline - typeBaseLine) - (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline + typeBaseLine) + (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

      if (type === 'attachmentLevel') {

        const baseline: number = 100;
        const typeBaseLine: number = 20;
        const pointArray: number[] = [];

        const toothKeys: string[] = [
          'LingualClinicalAttachmentLevelD',
          'LingualClinicalAttachmentLevelC',
          'LingualClinicalAttachmentLevelM',
        ];

        // starting point, height (x, y)

        this.lowerTeethIndices.forEach((toothIndex, i) => {
          const tooth = this.chartTeeth[toothIndex.index];
          let keyArray: string[] = JSON.parse(JSON.stringify(toothKeys));

          if (i >= 8) {
            keyArray = keyArray.reverse();
          }

          const startingXPointForTooth: number = i * (toothWidth + offset);

          keyArray.forEach((key, j) => {
            const startingXPointForPoint: number = j * pointWidth;
            const toothValue: number = tooth[key];

            if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
              const x = startingXPointForTooth + startingXPointForPoint;
              const y = (baseline - typeBaseLine) - (toothValue * 3);
              pointArray.push(x);
              pointArray.push(y);
            }

          });

        });

        // this.chartTeeth.forEach((tooth, i) => {
        //  let startingXPointForTooth: number = i * (toothWidth + offset);

        //  toothKeys.forEach((key, j) => {
        //    let startingXPointForPoint: number = j * pointWidth;
        //    let toothValue: number = tooth[key];

        //    if (!isNaN(toothValue) && toothValue != null && !tooth.ToothIsMissing) {
        //      var x = startingXPointForTooth + startingXPointForPoint;
        //      var y = (baseline + typeBaseLine) + (toothValue * 3);
        //      pointArray.push(x);
        //      pointArray.push(y);
        //    }

        //  });
        // });

        let pointString = '';
        pointArray.forEach((point, i) => {
          if (i !== 0) {
            pointString += ',';
          }
          pointString += `${point}`;
        });

        return pointString;
      }

    }

  }


  onCompareWith(item: any, isRealTime: boolean) {
    this.chartlist.find(x => x.PerioChartID === this.currentPerioChartID).isComparing = true ;
    this.chartlist.find(x => x.PerioChartID === item).isComparing = true ;
    this.isComparison = true;
    if (isRealTime){
      this.loadToothDataForComparisonChart(item);
    }else {
      this.getComparisonReport(item);
    }
  }
  onCreatePerioChartReport(PerioChartID: string){
    const reportGlobalParameters = new ReportGlobalParametersModel();
    reportGlobalParameters.TDOCID = this.globals.TDOCID;
    reportGlobalParameters.LOCID = this.globals.LOCID;
    reportGlobalParameters.PatientID = this.globals.currentPatientId;
    reportGlobalParameters.currentPerioChartID = this.currentPerioChartID;

    const reportStartUpInstructions = new ReportStartUpInstructionsModel();
    reportStartUpInstructions.enumReportCategoryID = '';
    reportStartUpInstructions.ReportID = this.PerioChartReportID;
    reportStartUpInstructions.ShowViewer = false;
    reportStartUpInstructions.SavePDF = true;
    reportStartUpInstructions.Print = '';


    const reportStartUpObject = new ReportStartUpObjectModel();
    reportStartUpObject.reportStartUpInstructions = reportStartUpInstructions;
    reportStartUpObject.reportGlobalParameters = reportGlobalParameters;

    localStorage.setItem('object', JSON.stringify(reportStartUpObject));
    const detailPage = window.open('/reports', '_blank', 'toolbar=1,location=0,menubar=1');
  }
  getComparisonReport(oldPerioChartID: string){
    const reportGlobalParameters = new ReportGlobalParametersModel();
    reportGlobalParameters.TDOCID = this.globals.TDOCID;
    reportGlobalParameters.LOCID = this.globals.LOCID;
    reportGlobalParameters.PatientID = this.globals.currentPatientId;
    reportGlobalParameters.currentPerioChartID = this.currentPerioChartID;
    reportGlobalParameters.oldPerioChartID = oldPerioChartID;


    const reportStartUpInstructions = new ReportStartUpInstructionsModel();
    reportStartUpInstructions.enumReportCategoryID = '';
    reportStartUpInstructions.ReportID = this.ComparisonReportID;
    reportStartUpInstructions.ShowViewer = false;
    reportStartUpInstructions.SavePDF = true;
    reportStartUpInstructions.Print = '';


    const reportStartUpObject = new ReportStartUpObjectModel();
    reportStartUpObject.reportStartUpInstructions = reportStartUpInstructions;
    reportStartUpObject.reportGlobalParameters = reportGlobalParameters;

    localStorage.setItem('object', JSON.stringify(reportStartUpObject));
    const detailPage = window.open('/reports', '_blank', 'toolbar=1,location=0,menubar=1');
  }


  filterNotesByGroupObject(PerioChartID: string) {
    const model = new TdoNoteQueryModel();
    model.parentObjectName = 'dataPerioChartTeeth';
    model.objectId = PerioChartID;
    model.patientId = this.globals.currentPatientId;
    this.notesService.changeNoteQuery(model);
  }
}
